export default "__VITE_ASSET__CBydGjZJ__"